import { createPortal } from 'react-dom';
import './styles.scss';
import { useRef } from 'react';
import { useClickOutside } from 'common/hooks';
import { CloseIcon } from 'assets/icons/CloseIcon';

export const AmenityModal = ({
  open,
  onClose,
  clickedAmenity,
  currentFloor,
}) => {
  const closeRef = useRef(null);
  const outsideRef = useClickOutside(() => onClose(), [closeRef]);
  if (!open) return null;

  const amenity = currentFloor.amenities.find((a) => a.id === clickedAmenity);

  if (!amenity || !amenity.img) return null;

  return createPortal(
    <div className="amenity-modal">
      <div className="modal-backdrop" />
      <button className="close-btn" onClick={onClose} ref={closeRef}>
        <CloseIcon color="#fff" />
      </button>
      <div className="modal-content" ref={outsideRef}>
        <img src={amenity.img} alt={amenity.name} />
        <p>{amenity.name}</p>
      </div>
    </div>,
    document.body
  );
};
